'use client'

import React, { useEffect, useState } from 'react'
import { client } from '@/app/lib/sanity.client'
import { DownloadQuery } from '@/app/queries/molecules/DownloadQuery'
import Heading from '../atoms/Heading'
import Paragraph from '../atoms/Paragraph'
import Section from '../sections/Section'
import Icon from '../atoms/Icons'
import { clean } from '~/app/utils/sanitizeString'

const PdfDownloader = ({ data }) => {
  const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return '0 Bytes'
    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
  }
  return (
    <Section
      variant="lys"
      className=""
      paddingBottom={clean(data.design?.padding?.spacingBottom)}
      paddingTop={clean(data.design?.padding?.spacingTop)}
    >
      <div
        className={`
      ${
        data?.alignment === 'center'
          ? 'col-start-1 -col-end-1 2xl:col-start-7 2xl:-col-end-7 lg:col-start-3 lg:-col-end-3 md:col-start-3 md:-col-end-3 xl:col-start-6 xl:-col-end-6 sm:col-start-2 sm:-col-end-2'
          : data?.alignment === 'right'
            ? 'col-start-1 -col-end-1 sm:col-start-3 sm:-col-end-1 md:col-start-5 md:-col-end-1 lg:col-start-5 lg:-col-end-1 xl:col-start-13 xl:-col-end-1 2xl:col-start-13 2xl:-col-end-1'
            : 'col-start-1 -col-end-1 sm:col-start-1 sm:-col-end-3 md:col-start-1 md:-col-end-5 lg:col-start-1 lg:-col-end-5 xl:col-start-1 xl:-col-end-13 2xl:col-start-1 2xl:-col-end-13'
      }`}
      >
        <Heading tag="h3" type="h3" spacing="small">
          {data.title}
        </Heading>
        <Paragraph>{data?.description}</Paragraph>
        <ul className="pt-8">
          {data.files &&
            data.files.map((file, index) => (
              <li
                className="w-full group  text-left border-b-2 border-rødtekst/50 flex items-center transition-all duration-500 ease-in-out"
                key={index}
              >
                <a
                  href={file.file.asset.url}
                  download
                  target="_blank"
                  rel="noopener noreferrer"
                  className="py-6 group-hover:prose-headings:text-rød group-focus-within:prose-headings:text-rød w-full transition-all duration-500 ease-in-out"
                >
                  {' '}
                  <div className="flex items-center justify-between">
                    <Heading tag="h5" type="h5" className="m-0 sm:w-[75%]" dangerouslySetInnerHTML={{__html: file.title}} />
                    <div>
                      <div className="flex items-center flex-col-reverse gap-2 uppercase sm:gap-4 sm:flex-row prose-p:text-DabraRød group-hover:prose-p:text-rød group-focus-within:prose-p:text-rød prose-p:text-small">
                        {file.file.asset.size ? (
                          <>
                            <Paragraph spacing="none" weight="medium" className='text-nowrap'>
                              {formatBytes(file.file.asset.size)}
                            </Paragraph>
                          </>
                        ) : null}
                        <span className="md:mr-4 md:ml-0 mx-auto text-DabraRød transition-all duration-500 ease-in-out transform scale-100 opacity-100">
                          <Icon
                            className="fill-DabraRød sm:size-8 size-6 group-hover:fill-rød group-focus-within:fill-rød"
                            type="download"
                          />
                        </span>{' '}
                      </div>
                    </div>
                  </div>
                </a>
              </li>
            ))}
        </ul>
      </div>
    </Section>
  )
}

export default PdfDownloader
